import React from 'react'
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import TopTeams from "../Components/TopTeams";
import PrevArrow from "../Components/PrevArrow";
import NextArrow from "../Components/NextArrow";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const InformationWithTeam = () => {
  const { t } = useTranslation();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { language } = useSelector((state) => state.language);

	const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 1 }
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <main className="main p-4 relative">
			<div className="flex flex-wrap items-start gap-y-6 -mx-2">
				<div className="lg:w-4/6 w-full px-2">
					<div className="space-y-5">
						<div className="relative">
							<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
								<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -left-12 bottom-0 bg-[#003C6E] before:content-[''] before:absolute before:w-1/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div>
								<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 bg-[#FFD600] before:content-[''] before:absolute before:w-1/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
							</div>
							<div className="relative bg-cover bg-no-repeat bg-center h-full text-center">
								<div className="flex max-sm:flex-wrap lg:justify-between justify-center items-center size-full">
									<div className="flex-none w-1/2 lg:w-1/4 p-4 relative flex justify-end">
										<div className="size-32 flex justify-center items-center p-4 rounded-full border light-border bg-white shadow-xl">
											<img src={require("../../assets/images/clubs/paris.png")} alt="" />
										</div>
									</div>
									<div className="p-5 flex justify-center items-center max-sm:order-last w-full lg:w-2/4">
										<div className="space-y-2">
											<h4 className="lg:text-xl md:text-lg text-base font-bold uppercase text-gray-400">30 August 2025</h4>
											<p className="my-5 font-secondary lg:text-6xl text-3xl font-black leading-none text-gray-800">1:00</p>
											<p className="font-secondary lg:text-xl font-bold md:text-lg text-base uppercase text-gray-400">Racing Club de Lens Stade Brestois 29</p>
										</div>
									</div>
									<div className="flex-none w-1/2 lg:w-1/4 p-4 relative flex justify-start">
										<div className="size-32 flex justify-center items-center p-4 rounded-full border light-border bg-white shadow-xl">
											<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="relative space-y-5">
							<div class="panel space-y-4">
								<div class="panel-header">
									<div class="flex justify-between items-center gap-3 w-full">
										<h3 class="xl:text-lg text-base font-extrabold uppercase">Joueurs</h3>
										<Link to={''} class="btn btn-primary text-nowrap ml-auto">Edit Players</Link>
									</div>
								</div>
								<div class="panel-body w-full">
									<div class="relative">
										<img src={require("../../assets/images/football-ground.png")} alt="" />
										<div class="p-5 absolute inset-0">
											<div class="flex justify-center items-center h-full w-full">
												<div class="w-1/5 px-2 md:space-y-8 space-y-3">
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/1.png")} alt="" />
													</div>
												</div>
												<div class="w-1/5 px-2 md:space-y-8 space-y-3">
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/2.png")} alt="" />
													</div>
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/3.png")} alt="" />
													</div>
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/4.png")} alt="" />
													</div>
												</div>
												<div class="w-1/5 px-2 md:space-y-8 space-y-3">
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/5.png")} alt="" />
													</div>
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/6.png")} alt="" />
													</div>
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/1.png")} alt="" />
													</div>
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/2.png")} alt="" />
													</div>
												</div>
												<div class="w-1/5 px-2 md:space-y-8 space-y-3">
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/3.png")} alt="" />
													</div>
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/4.png")} alt="" />
													</div>
													<div class="md:size-[5vw] size-[8vw] rounded-full bg-white md:p-3 p-1 overflow-hidden">
														<img src={require("../../assets/images/players-list/5.png")} alt="" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="relative text-center space-y-4 p-4 rounded-xl bg-gray-50">
								<h4 className="lg:text-xl md:text-lg text-base font-bold uppercase">Confrontations</h4>
								<div className="flex max-sm:flex-wrap lg:justify-between justify-center items-center size-full">
									<div className="flex-none w-24 relative flex justify-end">
										<div className="size-24 flex justify-center items-center p-4 rounded-full">
											<img src={require("../../assets/images/clubs/paris.png")} alt="" />
										</div>
									</div>
									<div className="p-5 flex flex-col justify-center items-center max-sm:order-last w-full">
										<div className="space-y-2 w-full">
											<div className="flex w-full overflow-hidden rounded-xl font-bold text-white text-sm select-none">
												<div className="flex-none w-[45%] bg-[#003C6E] flex justify-center items-center relative">
													<span className="p-2">45%</span>
												</div>

												<div className="flex-none w-[5%] bg-gray-200 text-black flex justify-center items-center relative z-[1] after:content-[''] after:absolute after:top-0 after:left-[-10px] after:bottom-0 after:right-[-10px] after:bg-gray-200 after:skew-x-12">
													<span className="p-2 relative z-[2]">5%</span>
												</div>

												<div className="flex-none w-[50%] bg-[#EAC600] text-white flex justify-center items-center rounded-r-xl">
													<span className="p-2">50%</span>
												</div>
											</div>
										</div>
									</div>
									<div className="flex-none w-24 relative flex justify-start">
										<div className="size-24 flex justify-center items-center p-4 rounded-full">
											<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
										</div>
									</div>
								</div>
								<h4 className="lg:text-xl md:text-lg text-base font-bold uppercase">View the previous 5 matches</h4>

								<div className='divide-y divide-gray-200'>
									<div className='flex justify-center items-center gap-2 py-3'>
										<div className='w-2/5 px-5'>
											<div className='flex justify-end items-center gap-3'>
												<div className='flex items-center gap-2'>
													<div className='font-secondary text-lg font-extrabold'>PSG</div>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/paris.png")} alt="" />
													</div>
												</div>
												<div className='font-secondary text-base font-extrabold'>2</div>
											</div>
										</div>
										<div className='w-3'>
											<div className='w-full h-0.5 bg-gray-300'></div>
										</div>
										<div className='w-2/5 px-5'>
											<div className='flex items-center gap-3'>
												<div className='font-secondary text-base font-extrabold text-gray-400'>1</div>
												<div className='flex items-center gap-2'>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
													</div>
													<div className='font-secondary text-lg font-extrabold text-gray-400'>RCL</div>
												</div>
											</div>
										</div>
									</div>
									<div className='flex justify-center items-center gap-2 py-3'>
										<div className='w-2/5 px-5'>
											<div className='flex justify-end items-center gap-3'>
												<div className='flex items-center gap-2'>
													<div className='font-secondary text-lg font-extrabold'>PSG</div>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/paris.png")} alt="" />
													</div>
												</div>
												<div className='font-secondary text-base font-extrabold'>2</div>
											</div>
										</div>
										<div className='w-3'>
											<div className='w-full h-0.5 bg-gray-300'></div>
										</div>
										<div className='w-2/5 px-5'>
											<div className='flex items-center gap-3'>
												<div className='font-secondary text-base font-extrabold text-gray-400'>1</div>
												<div className='flex items-center gap-2'>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
													</div>
													<div className='font-secondary text-lg font-extrabold text-gray-400'>RCL</div>
												</div>
											</div>
										</div>
									</div>
									<div className='flex justify-center items-center gap-2 py-3'>
										<div className='w-2/5 px-5'>
											<div className='flex justify-end items-center gap-3'>
												<div className='flex items-center gap-2'>
													<div className='font-secondary text-lg font-extrabold'>PSG</div>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/paris.png")} alt="" />
													</div>
												</div>
												<div className='font-secondary text-base font-extrabold'>2</div>
											</div>
										</div>
										<div className='w-3'>
											<div className='w-full h-0.5 bg-gray-300'></div>
										</div>
										<div className='w-2/5 px-5'>
											<div className='flex items-center gap-3'>
												<div className='font-secondary text-base font-extrabold text-gray-400'>1</div>
												<div className='flex items-center gap-2'>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
													</div>
													<div className='font-secondary text-lg font-extrabold text-gray-400'>RCL</div>
												</div>
											</div>
										</div>
									</div>
									<div className='flex justify-center items-center gap-2 py-3'>
										<div className='w-2/5 px-5'>
											<div className='flex justify-end items-center gap-3'>
												<div className='flex items-center gap-2'>
													<div className='font-secondary text-lg font-extrabold'>PSG</div>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/paris.png")} alt="" />
													</div>
												</div>
												<div className='font-secondary text-base font-extrabold'>2</div>
											</div>
										</div>
										<div className='w-3'>
											<div className='w-full h-0.5 bg-gray-300'></div>
										</div>
										<div className='w-2/5 px-5'>
											<div className='flex items-center gap-3'>
												<div className='font-secondary text-base font-extrabold text-gray-400'>1</div>
												<div className='flex items-center gap-2'>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
													</div>
													<div className='font-secondary text-lg font-extrabold text-gray-400'>RCL</div>
												</div>
											</div>
										</div>
									</div>
									<div className='flex justify-center items-center gap-2 py-3'>
										<div className='w-2/5 px-5'>
											<div className='flex justify-end items-center gap-3'>
												<div className='flex items-center gap-2'>
													<div className='font-secondary text-lg font-extrabold'>PSG</div>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/paris.png")} alt="" />
													</div>
												</div>
												<div className='font-secondary text-base font-extrabold'>2</div>
											</div>
										</div>
										<div className='w-3'>
											<div className='w-full h-0.5 bg-gray-300'></div>
										</div>
										<div className='w-2/5 px-5'>
											<div className='flex items-center gap-3'>
												<div className='font-secondary text-base font-extrabold text-gray-400'>1</div>
												<div className='flex items-center gap-2'>
													<div className='flex-none size-12'>
														<img src={require("../../assets/images/clubs/rcl.png")} alt="" />
													</div>
													<div className='font-secondary text-lg font-extrabold text-gray-400'>RCL</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="flex flex-wrap -mx-2">
								<div class="xs:w-1/2 w-full px-2">
									<div class="space-y-4">
										<div class="panel rounded-xl border light-border bg-white p-4 space-y-2">
											<div class="panel-header w-full flex flex-wrap justify-between items-center gap-3">
												<h3 class="xl:text-lg text-base font-extrabold uppercase">Attacking</h3>
											</div>
											<div class="panel-body w-full">
												<table class="table w-full">
													<thead class="border-b light-border">
														<tr>
															<th>Temps</th>
															<th class="text-right">Points</th>
														</tr>
													</thead>

													<tbody class="divide-y divide-gray-200 font-secondary font-bold uppercase">
														<tr>
															<td><span class="text-gray-500">Ratio:</span></td>
															<td class="text-right">1 goal/805min</td>
														</tr>
														<tr>
															<td><span class="text-gray-500">Penalty area balls played:</span></td>
															<td class="text-right">4.47/Match</td>
														</tr>
														<tr>
															<td><span class="text-gray-500">Left feet:</span></td>
															<td class="text-right">3 goals</td>
														</tr>
														<tr>
															<td><span class="text-gray-500">Shots on target per match:</span></td>
															<td class="text-right">4.47%</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div class="panel rounded-xl border light-border bg-white p-4 space-y-2">
											<div class="panel-header w-full flex flex-wrap justify-between items-center gap-3">
												<h3 class="xl:text-lg text-base font-extrabold uppercase">Collective</h3>
											</div>
											<div class="panel-body w-full">
												<table class="table w-full">
													<thead class="border-b light-border">
														<tr>
															<th>Temps</th>
															<th class="text-right">Points</th>
														</tr>
													</thead>

													<tbody class="divide-y divide-gray-200 font-secondary font-bold uppercase">
														<tr>
															<td><span class="text-gray-500">Number of chances:</span></td>
															<td class="text-right">16 attempts</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
								<div class="xs:w-1/2 w-full px-2">
									<div class="space-y-4">
										<div class="panel rounded-xl border light-border bg-white p-4 space-y-2">
											<div class="panel-header w-full flex flex-wrap justify-between items-center gap-3">
												<h3 class="xl:text-lg text-base font-extrabold uppercase">Defensive</h3>
											</div>
											<div class="panel-body w-full">
												<table class="table w-full">
													<thead class="border-b light-border">
														<tr>
															<th>Temps</th>
															<th class="text-right">Points</th>
														</tr>
													</thead>

													<tbody class="divide-y divide-gray-200 font-secondary font-bold uppercase">
														<tr>
															<td><span class="text-gray-500">Duels won:</span></td>
															<td class="text-right">88</td>
														</tr>
														<tr>
															<td><span class="text-gray-500">Ball recoveries:</span></td>
															<td class="text-right">0.33/Match</td>
														</tr>
														<tr>
															<td><span class="text-gray-500">Tackles:</span></td>
															<td class="text-right">6</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
										<div class="panel rounded-xl border light-border bg-white p-4 space-y-2">
											<div class="panel-header w-full flex flex-wrap justify-between items-center gap-3">
												<h3 class="xl:text-lg text-base font-extrabold uppercase">Discipline</h3>
											</div>
											<div class="panel-body w-full">
												<table class="table w-full">
													<thead class="border-b light-border">
														<tr>
															<th>Temps</th>
															<th class="text-right">Points</th>
														</tr>
													</thead>

													<tbody class="divide-y divide-gray-200 font-secondary font-bold uppercase">
														<tr>
															<td><span class="text-gray-500">Fouls committed:</span></td>
															<td class="text-right">17</td>
														</tr>
														<tr>
															<td><span class="text-gray-500">Fouls suffered:</span></td>
															<td class="text-right">14</td>
														</tr>
														<tr>
															<td><span class="text-gray-500">Yellow cards:</span></td>
															<td class="text-right">3</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
						<div className="space-y-5">
								<div className="panel">
										{/* <div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
												<div className="flex justify-between gap-3 w-full">
														<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button>
														<h3 className="xl:text-lg text-base font-extrabold uppercase">Lecture en cours</h3>
														<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button>
												</div>
										</div> */}
										<div className="panel-body w-full space-y-8">
												<div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
														<div className="p-5 relative space-y-3">
																<div className="flex justify-between items-center gap-4 w-full">
																		<div className="flex-1 font-secondary lg:text-3xl text-2xl uppercase font-black bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">sÊrie de victoires</div>
																		<div className="flex-none pr-5">
																				<span className="flex-1 font-secondary lg:text-5xl text-4xl uppercase font-black ">70%</span>
																		</div>
																</div>
														</div>
												</div>
										</div>
								</div>

								<TopTeams />

								<div className="panel space-y-3">
                  <div className="panel-header w-full">
										<h3 className="xl:text-lg text-base font-extrabold uppercase">{t('bestPlayers')}</h3>
                  </div>
                  <div className="panel-body w-full space-y-4 [&_.slick-arrow]:-top-7 [&_.slick-arrow]:z-10 before:[&_.slick-arrow]:hidden [&_.slick-prev]:left-0 [&_.slick-next]:right-0 ">
                    <Slider {...settings}>
                      <div class="relative">
												<div class="rounded-xl absolute inset-0 top-5 bg-[#F8F8F8] overflow-hidden">
													<div class="absolute -skew-x-[20deg] w-[4vw] top-0 -left-12 bottom-0 bg-[#3D54AC]"></div>
													<div class="absolute -skew-x-[20deg] w-[18vw] top-0 -right-12 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
												</div>
												<div class="relative bg-cover bg-no-repeat bg-center h-full mt-5">
													<div class="flex lg:justify-end justify-center max-sm:flex-wrap gap-y-3 w-full">
														<div class="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
															<img src="assets/images/club-players/paris.png" alt="" class="max-w-full lg:max-h-[276px] inline-block" />
														</div>
													</div>
													<div class="absolute left-0 bottom-0 right-0 p-4 flex justify-between items-end gap-6 bg-gradient-to-t from-[#3D54AC] rounded-b-xl overflow-hidden">
														<div class="">
															<div class="space-y-2">
																<div class="flex items-center gap-x-4">
																	<span class="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
																		<img src="assets/images/icons/star-fill.svg" alt="Star" width="16" class="icon-white"/> 4.5
																	</span>
																</div>

																<h4 class="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">Ousmane Dembélé</h4>
															</div>
														</div>
														<div class="">
															<Link to={''} class="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</Link>
														</div>
													</div>
												</div>
											</div>
                      <div class="relative">
												<div class="rounded-xl absolute inset-0 top-5 bg-[#F8F8F8] overflow-hidden">
													<div class="absolute -skew-x-[20deg] w-[4vw] top-0 -left-12 bottom-0 bg-gray-800"></div>
													<div class="absolute -skew-x-[20deg] w-[18vw] top-0 -right-12 bottom-0 bg-gray-800 before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
												</div>
												<div class="relative bg-cover bg-no-repeat bg-center h-full mt-5">
													<div class="flex lg:justify-end justify-center max-sm:flex-wrap gap-y-3 w-full">
														<div class="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
															<img src="assets/images/club-players/mesi.png" alt="" class="max-w-full lg:max-h-[276px] inline-block" />
														</div>
													</div>
													<div class="absolute left-0 bottom-0 right-0 p-4 flex justify-between items-end gap-6 bg-gradient-to-t from-gray-800 rounded-b-xl overflow-hidden">
														<div class="">
															<div class="space-y-2">
																<div class="flex items-center gap-x-4">
																	<span class="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
																		<img src="assets/images/icons/star-fill.svg" alt="Star" width="16" class="icon-white"/> 4.5
																	</span>
																</div>

																<h4 class="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">Lionel Messi</h4>
															</div>
														</div>
														<div class="">
															<Link to={''} class="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</Link>
														</div>
													</div>
												</div>
											</div>
                    </Slider>
                  </div>
                </div>
						</div>
					</div>
			</div>
		</main>
  )
}

export default InformationWithTeam